/**
 * Rolling report reference ID (e.g. "NRC-SOM-EVI-0001"). Deterministic and
 * storage-free: the sequence number is purely a function of the calendar
 * date, so it's always correct across devices/sessions with nothing to
 * persist or keep in sync. Multiple reports generated the same day share
 * the same number (matches "if today is 1, tomorrow it's 2" — the
 * sequence advances by day, not by generation count).
 *
 * EPOCH is day 1 of the sequence — set this to when this reporting
 * feature actually goes live, then leave it alone forever.
 */
const REPORT_ID_EPOCH = new Date('2026-01-01T00:00:00Z');

export function computeReportSequence(now: Date): number {
  const msPerDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.floor((now.getTime() - REPORT_ID_EPOCH.getTime()) / msPerDay);
  return Math.max(1, diffDays + 1);
}

export function formatReportId(now: Date): string {
  const seq = computeReportSequence(now);
  return `NRC-SOM-EVI-${String(seq).padStart(4, '0')}`;
}